import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import Merchants from './pages/Merchants';
import Affiliations from './pages/Affiliations';
import Terminals from './pages/Terminals';
import Transactions from './pages/Transactions';
import CopaymentLogs from './pages/CopaymentLogs';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<PrivateRoute />}>
                        <Route path="dashboard" element={<Dashboard />}>
                            <Route index element={<Navigate to="affiliations" replace />} />
                            <Route path="users" element={<UserManagement />} />
                            <Route path="affiliations" element={<Affiliations />} />
                            <Route path="merchants" element={<Merchants />} />
                            <Route path="terminals" element={<Terminals />} />
                            <Route path="transactions" element={<Transactions />} />
                            <Route element={<AdminRoute />}>
                                <Route path="copayment-logs" element={<CopaymentLogs />} />
                            </Route>
                        </Route>
                    </Route>
                    <Route path="*" element={<Navigate to="/dashboard" />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
